import { Pipe, PipeTransform } from '@angular/core';
import { IChatMarkdownTruncated, truncateChatMarkdown } from './chat-markdown.util';

/** Shortens Markdown for "Read More"; the result is Markdown again, rendered by <markdown>. Runs only when the content changes. */
@Pipe({ name: 'chatMarkdownTruncate', standalone: true, pure: true })
export class ChatMarkdownTruncatePipe implements PipeTransform {
  public transform(content: string | null | undefined, limit: number): IChatMarkdownTruncated {
    return content ? truncateChatMarkdown(content, limit) : { content: '', isTruncated: false };
  }
}
